import { useCookies } from 'react-cookie'

import { COOKIE_DATA } from '@/constants/cookieKey'

type LineRewardSource = {
  lineStatus?: boolean
  linePointFeedback?: boolean
  lineOnShelfDate?: string | number
  lineOffShelfDate?: string | number
}

const isWithinLineRewardPeriod = (onShelf?: string | number, offShelf?: string | number) => {
  const now = Date.now()
  if (onShelf) {
    const start = new Date(onShelf).getTime()
    if (!Number.isNaN(start) && now < start) return false
  }
  if (offShelf) {
    const end = new Date(offShelf).getTime()
    if (!Number.isNaN(end) && now > end) return false
  }
  return true
}

export const useShowLineRewardBadge = (source?: LineRewardSource | null) => {
  const [cookies] = useCookies([COOKIE_DATA.LINE_ECID])
  const hasEcid = !!cookies?.[COOKIE_DATA.LINE_ECID]

  if (source?.linePointFeedback !== undefined) {
    return source.linePointFeedback === true
  }

  return hasEcid && source?.lineStatus === true && isWithinLineRewardPeriod(source?.lineOnShelfDate, source?.lineOffShelfDate)
}
